<div class="w-100" [ngSwitch]="engagementService.flowStep">
  <ng-container *ngSwitchCase="EngagementTemplateFlowStepEnum.CHOOSE_TEMPLATE_MESSAGE">
    <ng-container [ngSwitch]="engagementService.strategy?.channelType || SiteTypeEnum.WhatsApp">
      <ng-container *ngSwitchCase="SiteTypeEnum.WhatsApp">
        <ng-container *ngIf="templates?.length; else noTemplatesFound">
          <app-choose-whatsapp-template [templates]="$any(templates)"></app-choose-whatsapp-template>
        </ng-container>
        <ng-template #noTemplatesFound>
          <div class="no-whatsapp-templates-found" translate="m/task-process/whatsapp-template/no-templates"></div>
        </ng-template>
      </ng-container>
      <ng-container *ngSwitchCase="SiteTypeEnum.Kakaotalk">
        <app-choose-kakaotalk-template
          [templates]="$any(templates)"
          *ngIf="templates?.length"></app-choose-kakaotalk-template>
      </ng-container>
    </ng-container>
  </ng-container>

  <app-choose-write
    *ngSwitchCase="EngagementTemplateFlowStepEnum.CHOOSE_WRITE_MESSAGE"
    [taskProcessContext]="taskProcessContext"
    [message]="engagementService.strategy.message">
    <ng-container *ngTemplateOutlet="processingPageSendButtons"></ng-container>
  </app-choose-write>

  <app-compose-message *ngSwitchCase="EngagementTemplateFlowStepEnum.COMPOSE_MESSAGE">
    <ng-container *ngTemplateOutlet="processingPageSendButtons"></ng-container>
  </app-compose-message>

  <app-preview-and-send
    *ngSwitchCase="EngagementTemplateFlowStepEnum.PREVIEW_AND_SEND_MESSAGE"
    [templateDisplayedBS]="chooseTemplateFlowService.templateDisplayedBS">
    <ng-container *ngTemplateOutlet="processingPageSendButtons"></ng-container>
  </app-preview-and-send>

  <ng-container *ngSwitchDefault>
    <app-choose-sender-recipient
      *ngIf="taskProcessContext.engagement; else whatsappTemplateMode"
      (getTemplatesForAccount)="getTemplatesForAccount.emit($event)"
      (tryToSearchConversation)="tryToSearchConversation.emit($event)">
    </app-choose-sender-recipient>
    <ng-template #whatsappTemplateMode>
      <ng-container *ngIf="templates?.length; else noTemplatesFound">
        <app-choose-whatsapp-template [templates]="$any(templates)"></app-choose-whatsapp-template>
      </ng-container>
      <ng-template #noTemplatesFound>
        <div class="no-whatsapp-templates-found" translate="m/task-process/whatsapp-template/no-templates"></div>
      </ng-template>
    </ng-template>
  </ng-container>
</div>

<ng-template #processingPageSendButtons>
  <ng-container *ngIf="taskProcessContext.engagement; else processingPageButtons">
    <ion-button
      fill="clear"
      class="tpp-send-icon-button"
      (click)="sendNow()"
      [disabled]="!chooseTemplateFlowService.isValid">
      <ion-icon slot="icon-only" name="send-sharp"></ion-icon>
    </ion-button>

    <div class="tpp-textual-send-buttons-container">
      <ion-button (click)="sendNow()" [disabled]="!chooseTemplateFlowService.isValid">
        {{ 'm/task-process/send-now' | translate }}
      </ion-button>
    </div>
  </ng-container>
  <ng-template #processingPageButtons>
    <ng-content></ng-content>
  </ng-template>
</ng-template>
